import { render } from "./JourneyPlus.vue?vue&type=template&id=a546a734"
import script from "./JourneyPlus.vue?vue&type=script&lang=js"
export * from "./JourneyPlus.vue?vue&type=script&lang=js"
script.render = render

export default script